import { DOCUMENT, isPlatformServer } from '@angular/common';
import { inject, Injectable, PLATFORM_ID, signal } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { AnalyticsEvent } from '../events/analytics-event';

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    dataLayer?: any[];
  }
}

@Injectable({
  providedIn: 'root',
})
export class AnalyticsService {
  private readonly isServer = isPlatformServer(inject(PLATFORM_ID));
  private readonly useGoogleTagManager = signal(true);
  private readonly useConsoleLog = signal(false);

  private readonly window: Window = inject(DOCUMENT).defaultView as Window;

  private readonly event: ReplaySubject<AnalyticsEvent> = new ReplaySubject<AnalyticsEvent>(1);
  public event$ = this.event.asObservable();

  configure(options: { consoleLogging?: boolean }): void {
    this.useConsoleLog.set(options.consoleLogging ?? false);
  }

  push<T extends AnalyticsEvent>(event: T): void {
    if (this.useConsoleLog()) this.logToConsole(event);

    if (this.isServer) return;
    if (!event?.event) return;

    if (this.useGoogleTagManager()) this.pushToTagManager(event);
    this.event.next(event);
  }

  private pushToTagManager(analyticsEvent: AnalyticsEvent): void {
    if (this.window?.dataLayer) {
      this.window.dataLayer.push(analyticsEvent);
    }
  }

  private logToConsole(analyticsEvent: AnalyticsEvent): void {
    // eslint-disable-next-line no-console
    console.table(analyticsEvent);
  }
}
